module.exports = __webpack_public_path__ + "img/portfolio-murfie.5257790b.jpg";